// import React, { Component } from 'react';
// import ReactResizeDetector from 'react-resize-detector';
//
//
/*
export default class CTAView extends React.Component {


  render() {

    
    return <div className="sce-CTAView"  >
        <div className="sce-ctaClose">X</div>                
        <div className="sce-ctaTitle">This is some amazing title. Wow that's cool.</div>                
        <div className="sce-ctaImage"><img src="https://www.fillmurray.com/200/300"/></div>                
        <div className="sce-ctaBody">What a groovy movie</div>                
        

            </div>;
  }

}
*/
import React, { useEffect, useState } from "react";

import "./CTAView.scss";

const CTAView = ({ show, hideCTA, cta, open, isMobile, position, collapsedStyle, windowSize, config }) => {
  const [shouldRender, setRender] = useState(show);

  useEffect(() => {
    if (show) setRender(true);
  }, [show]);

  const onAnimationEnd = () => {
    if (!show) setRender(false);
  };
  if (!isMobile && (position === "right" || position === "left")) {
    return null;
  }
  const className = "sce-CTAView cta_is_mobile_" + isMobile + " cta_position_" + position + " cta_postion_style_" + collapsedStyle;

  let style: any = { animation: `${show ? "sce-cta-fadeIn" : "sce-cta-fadeOut"} ${show ? "1s" : "0.3s"}` };
  if (isMobile) {
    style = { animation: `${show ? "sce-cta-fadeIn" : "sce-cta-fadeOut"} ${show ? "1s" : "0.3s"}`, transform: `translateY(-${windowSize.height}px)` };
  }
  if (!isMobile && config && config.collapsedStyle === "dot") {
    if (config.dotDesktopLeftOffset) {
      style.left = config.dotDesktopLeftOffset - 17 + "px";
    }
    if (config.dotDesktopRightOffset) {
      style.right = config.dotDesktopRightOffset - 17 + "px";
    }
  }

  if (config.dotOffsets) {
    if (config.dotOffsets.mobile && isMobile) {
      if (config.dotOffsets.mobile.top) {
        style.top = config.dotOffsets.mobile.top - 17 + "px";
      }
      if (config.dotOffsets.mobile.bottom) {
        style.bottom = config.dotOffsets.mobile.bottom - 17 + "px";
      }
      if (config.dotOffsets.mobile.left) {
        style.left = config.dotOffsets.mobile.left - 17 + "px";
      }
      if (config.dotOffsets.mobile.right) {
        style.right = config.dotOffsets.mobile.right - 17 + "px";
      }

      if (config.dotOffsets.desktop && !isMobile) {
        if (config.dotOffsets.desktop.top) {
          style.top = config.dotOffsets.mobile.top - 17 + "px";
        }
        if (config.dotOffsets.desktop.bottom) {
          style.bottom = config.dotOffsets.mobile.bottom - 17 + "px";
        }
        if (config.dotOffsets.desktop.left) {
          style.left = config.dotOffsets.mobile.left - 17 + "px";
        }
        if (config.dotOffsets.desktop.right) {
          style.right = config.dotOffsets.mobile.right - 17 + "px";
        }
      }
    }
  }

  return (
    shouldRender && (
      <div className={className} onClick={open} style={style} onAnimationEnd={onAnimationEnd}>
        <div className="sce-ctaClose" onClick={hideCTA}>
          X
        </div>
        <div className="sce-ctaTitle">{cta.title}</div>
        <div className="sce-ctaImage">
          <img src={cta.imageURL} alt={cta.title} />
        </div>
        <div className="sce-ctaBody">{cta.body}</div>
      </div>
    )
  );
};

export default CTAView;
